/**
 * BASForecastSection Component
 * Collapsible BAS forecast breakdown within Compliance tab
 */

import { SectionCard } from './SectionCard';
import { StatusBadge } from './StatusBadge';
import { formatCurrency, formatDate } from '@/utils/formatters';
import { dueDateUrgency, daysUntilLabel } from '@/utils/complianceDate';
import type { ComplianceSnapshotResponse } from '@/api/complianceApi';

interface BASForecastSectionProps {
  basForecast: ComplianceSnapshotResponse['data']['basForecast'];
}

export function BASForecastSection({ basForecast }: BASForecastSectionProps) {
  return (
    <SectionCard
      title="BAS Forecast"
      badge={
        <StatusBadge
          status={dueDateUrgency(basForecast.dueDate)}
          label={daysUntilLabel(basForecast.dueDate)}
          size="sm"
        />
      }
    >
      <div className="compliance-dashboard__bas">
        <div className="compliance-dashboard__bas-header">
          <span className="compliance-dashboard__bas-quarter">
            {basForecast.quarter}
          </span>
          <span className="compliance-dashboard__bas-due">
            Due: {formatDate(basForecast.dueDate, 'dd MMM yyyy')}
          </span>
        </div>
        <div className="compliance-dashboard__bas-grid">
          <div className="compliance-dashboard__bas-item">
            <span className="compliance-dashboard__bas-label">GST on Sales (1A)</span>
            <span className="compliance-dashboard__bas-value">
              {formatCurrency(basForecast.gstOnSales)}
            </span>
          </div>
          <div className="compliance-dashboard__bas-item">
            <span className="compliance-dashboard__bas-label">GST on Purchases (1B)</span>
            <span className="compliance-dashboard__bas-value">
              {formatCurrency(basForecast.gstOnPurchases)}
            </span>
          </div>
          <div className="compliance-dashboard__bas-item">
            <span className="compliance-dashboard__bas-label">PAYG Withholding (W2)</span>
            <span className="compliance-dashboard__bas-value">
              {formatCurrency(basForecast.paygWithholding)}
            </span>
          </div>
          <div className="compliance-dashboard__bas-item">
            <span className="compliance-dashboard__bas-label">PAYG Instalments (T7)</span>
            <span className="compliance-dashboard__bas-value">
              {formatCurrency(basForecast.paygInstalments)}
            </span>
          </div>
        </div>
        <div className="compliance-dashboard__bas-total">
          <span>Total BAS Payable</span>
          <span className="compliance-dashboard__bas-total-value">
            {formatCurrency(basForecast.totalPayable)}
          </span>
        </div>
      </div>
    </SectionCard>
  );
}
